/**
 * Vendor Vault — number formatting helpers.
 *
 * Use these EVERYWHERE money/percent/stock counts are shown so the app stays
 * consistent. Don't reach for raw `.toLocaleString()` or `.toFixed()` in
 * components — call these.
 */

/**
 * Money. Always shows 2 decimals (e.g. `$1,450.00`, `$0.90`).
 * Big numbers (>= $10,000) drop decimals for breathing room (e.g. `$12,345`).
 * Passes through `null`/`undefined`/non-finite values as `$0.00`.
 *
 * @param {number|string} n
 * @param {{ compact?: boolean }} [opts] - force compact (no decimals) regardless of size
 */
export function fmtMoney(n, opts = {}) {
  const v = Number(n);
  if (!Number.isFinite(v)) return "$0.00";
  if (opts.compact || Math.abs(v) >= 10000) {
    return `$${Math.round(v).toLocaleString("en-US")}`;
  }
  return `$${v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/** Money but ALWAYS shows full cents, even for big numbers. Use for CSV/exports/totals. */
export function fmtMoneyFull(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return "$0.00";
  return `$${v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/** Integer (stock counts, units, sales count). Commas, no decimals. */
export function fmtInt(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return "0";
  return Math.round(v).toLocaleString("en-US");
}

/** Percentage with 1 decimal (e.g. `33.3%`). */
export function fmtPct(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return "0.0%";
  return `${v.toFixed(1)}%`;
}

/** Plain decimal with 2 places (e.g. weights, costs in raw form). */
export function fmt2(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return "0.00";
  return v.toFixed(2);
}
